export default __webpack_public_path__ + "static/media/eBike-logo.20b0e67b.svg";